import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert as MUIAlert, styled, } from '@mui/material';
import { Info, CheckCircle, NewReleases, Error as ErrorFilled, } from '@mui/icons-material';
import { WarningIcon } from '../icons';
const AlertAction = styled('div')(({ theme }) => ({
    margin: theme.spacing(2, 0, 0, 0),
    width: '100%',
    alignSelf: 'flex-start',
    [theme.breakpoints.up('md')]: {
        margin: theme.spacing('-5px', 0, '-5px', 2),
        width: 'auto',
    },
    'button, a': {
        width: '100%',
        whiteSpace: 'nowrap',
    },
}));
export const Alert = ({ children, action, severity = 'info', icon, ...rest }) => {
    let defaultIcon;
    switch (severity) {
        case 'success':
            defaultIcon = _jsx(CheckCircle, { fontSize: "inherit", color: "inherit" });
            break;
        case 'warning':
            defaultIcon = _jsx(WarningIcon, { fontSize: "inherit", color: "inherit" });
            break;
        case 'secondary':
            defaultIcon = _jsx(NewReleases, { fontSize: "inherit", color: "inherit" });
            break;
        case 'error':
            defaultIcon = _jsx(ErrorFilled, { fontSize: "inherit", color: "inherit" });
            break;
        default:
            defaultIcon = _jsx(Info, { fontSize: "inherit", color: "inherit" });
    }
    return (_jsxs(MUIAlert, { icon: icon ?? defaultIcon, severity: severity === 'primary' || severity === 'secondary' ? 'info' : severity, color: severity, variant: "standard", ...rest, children: [_jsx("div", { children: children }), action && _jsx(AlertAction, { children: action })] }));
};
